/**
 * Plugin para limpeza automática do Service Worker
 * Remove service workers existentes e seus caches quando o PWA foi desabilitado
 */

export default defineNuxtPlugin(async () => {
	/*
	// Só executa no client-side
	if (process.server) return;

	// Flag para controlar se a limpeza já foi executada nesta sessão
	const SESSION_KEY = 'sw-cleanup-executed';

	// Verifica se já executou a limpeza nesta sessão para evitar loops
	if (sessionStorage.getItem(SESSION_KEY)) {
		return;
	}

	// Aguarda um pouco para garantir que a página carregou completamente
	await new Promise(resolve => setTimeout(resolve, 2000));

	try {
		// Verifica se há service workers registrados
		if ('serviceWorker' in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations();

			// Se há service workers registrados, executa a limpeza
			if (registrations.length > 0) {
				console.log(
					'🔄 Detectados service workers antigos. Iniciando limpeza...'
				);

				// Importa dinamicamente o utilitário de limpeza
				const { cleanupServiceWorker } = await import(
					'~/utils/serviceWorkerCleanup'
				);

				// Executa a limpeza
				const result = await cleanupServiceWorker();

				// Marca que a limpeza foi executada nesta sessão
				sessionStorage.setItem(SESSION_KEY, 'true');

				// Se houve sucesso e removeu algum SW, recarrega a página
				if (result.success && result.unregisteredCount > 0) {
					console.log(
						'🔄 Recarregando página após limpeza do service worker...'
					);

					// Aguarda um momento e recarrega
					setTimeout(() => {
						window.location.reload();
					}, 1000);
				}
			} else {
				// Se não há service workers, apenas marca como executado
				sessionStorage.setItem(SESSION_KEY, 'true');
			}
		}
	} catch (error) {
		console.error('Erro durante limpeza automática do service worker:', error);
		// Marca como executado mesmo com erro para evitar loops
		sessionStorage.setItem(SESSION_KEY, 'true');
	}
	*/
});
